// add listener + fire event if selected
document.querySelectorAll('.radio__fieldset--swatches .radio__buttons input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', hideOtherColorImages);
  if (radio.checked) { 
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  };
});

// to get all images
function hideOtherColorImages(event) {
  const finalSaleInput = document.getElementById('final_price_property');
  finalSaleInput.removeAttribute('name');
  const productElem = document.querySelector('.product__page');
  curColorCode = productElem.querySelector('.product__sku')?.textContent?.split('-')?.[1];
  if (!curColorCode) { return true; }
  let firstOne = true;
  productElem.querySelectorAll('.product__slide').forEach(image => {
    if (image.getAttribute('data-color').toLowerCase() === curColorCode.toLowerCase()) {
      image.style.display = '';
      if (firstOne) {
        image.style.columnSpan = 'all';
      }
      firstOne = false;
    } else {
      image.style.display = 'none';
      image.style.columnSpan = 'none';
    }
    if (image.querySelector('img').src.includes("AMZ_")) {
      image.style.display = 'none';
      image.style.columnSpan = 'none';
    }
  });
  productElem.querySelectorAll('.product__thumb').forEach(image => {
    if (image.getAttribute('data-color').toLowerCase() === curColorCode.toLowerCase()) {
      image.style.display = '';
    } else {
      image.style.display = 'none';
    }
    if (image.querySelector('img').src.includes("AMZ_")) {
      image.style.display = 'none';
    }
  });
  window.scrollTo({top:0, behavior: 'smooth'});
};
